/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/**
 * 年
 */
export const YEAR_TO_DAY = 365;
/**
 * 月
 */
export const MONTH_TO_DAY = 31;
/**
 * 日
 */
export const YEAR_TO_MONTH = 12;
/**
 * 小时
 */
export const DAY_TO_HOUR = 24;
/**
 * 分钟
 */
export const HOUR_TO_MINUTE = 60;